import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {Icon} from 'platform/foundation';
import styled from 'styled-components';

import {testIds} from '@dms/routes';

import {FilterPresetButton, FilterPresetButtonProps} from './FilterPresetButton';

export function SortableFilterPresetButton(props: FilterPresetButtonProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.id,
  });
  const transformString = CSS.Transform.toString(transform);

  return (
    <SortableWrapper
      ref={setNodeRef}
      $isDragging={isDragging}
      $transform={transformString}
      $transition={transition}
      {...attributes}
    >
      <DragHandle {...listeners}>
        <Icon
          value="action/drag_indicator"
          color="palettes.neutral.60.100"
          data-testid={testIds.sourcing.classifieds('filterPresetButtons-drag')}
        />
      </DragHandle>
      <FilterPresetButton {...props} />
    </SortableWrapper>
  );
}

const SortableWrapper = styled.div<{
  $isDragging: boolean;
  $transform: string | undefined;
  $transition: string | undefined;
}>`
  display: flex;
  align-items: center;
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0 : 1)};
`;

const DragHandle = styled.div`
  cursor: grab;
  display: flex;
  align-items: center;
`;
